import { render, staticRenderFns } from "./LAvatar.vue?vue&type=template&id=d48634a8"
import script from "./LAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LAvatar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports